/* eslint-disable no-undef */
/* eslint-disable import/no-extraneous-dependencies */
import * as styled from 'styled-components';

const path = 'https://d11zrgpbhs014a.cloudfront.net/assets/fonts/SBS_Sans_3/';
const path2 = 'https://d11zrgpbhs014a.cloudfront.net/assets/fonts/SBS_Sans_2/';

export default styled.createGlobalStyle`
  html {
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
  }

  body {
    width: 100%;
    position: relative;
    left: 0;
    -webkit-overflow-scrolling: touch;
    line-height: 1.5em;
    font-family: 'SBS Sans', sans-serif;
    font-weight: 400;
    font-size: 16px;
    margin: 0;
    padding: 0;
  }

  @font-face {
    font-family: 'SBS Sans';
    src:
      url('${path}WOFF2/SBSSans-Regular.woff2') format('woff2'),
      url('${path}WOFF/SBSSans-Regular.woff') format('woff');
    font-weight: 400;
    font-style: normal;
    font-stretch: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'SBS Sans';
    src:
      url('${path}WOFF2/SBSSans-Bold.woff2') format('woff2'),
      url('${path}WOFF/SBSSans-Bold.woff') format('woff');
    font-weight: 700;
    font-style: normal;
    font-stretch: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'SBS Sans';
    src:
      url('${path}WOFF2/SBSSans-Medium.woff2') format('woff2'),
      url('${path}WOFF/SBSSans-Medium.woff') format('woff');
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'SBS Sans';
    src:
      url('${path}WOFF2/SBSSansCond-Bold.woff2') format('woff2'),
      url('${path}WOFF/SBSSansCond-Bold.woff') format('woff');
    font-weight: 700;
    font-style: normal;
    font-stretch: condensed;
    font-display: swap;
  }

  @font-face {
    font-family: 'SBS Sans';
    src:
      url('${path}WOFF2/SBSSansCond-Regular.woff2') format('woff2'),
      url('${path}WOFF/SBSSansCond-Regular.woff') format('woff');
    font-weight: 400;
    font-style: normal;
    font-stretch: condensed;
    font-display: swap;
  }

  @font-face {
    font-family: 'SBS Sans';
    src:
      url('${path}WOFF2/SBSSansCond-Medium.woff2') format('woff2'),
      url('${path}WOFF/SBSSansCond-Medium.woff') format('woff');
    font-weight: 500;
    font-style: normal;
    font-stretch: condensed;
    font-display: swap;
  }

  @font-face {
    font-family: 'SBS Sans 2';
    src: url('${path2}WOFF2/SBSSansWide2.0-Regular.woff2') format('woff2');
    font-weight: 400;
    font-style: normal;
    font-stretch: normal;
    font-display: swap;
  }

  .bracket-wrap {
    position: relative;
    width: 994px;
    height: 640px;
    background: #4a148c;
  }
`;
